export default __webpack_public_path__ + "static/media/Comfortaa-Bold.4ccfbb46.ttf";